// extracted by mini-css-extract-plugin
module.exports = {"image":"ImageRenderer_image__3oCXu"};